import * as jose from 'jose';

import type { ADCJWTPayload } from './types';

export const decodeJwt = (token: string) => {
  const payload = jose.decodeJwt<ADCJWTPayload>(token);

  if (typeof payload.role !== 'string' || typeof payload.userID !== 'string') {
    throw new Error('Invalid JWT payload');
  }

  return payload;
};
